export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {
		const facilitycards = document.querySelectorAll('.facility-card');

		function hashHandler() {
			if (window.location.hash) {
				var hash = window.location.hash.substring(2, window.location.hash.length - 1);

				if (hash == '/') {
					facilitycards.forEach(otherCard => {
						otherCard.querySelector('.facility-popup').classList.remove('open');
						// Remove the "show" class from .popup-overlay when "open" is removed
						const popupOverlay = document.body.querySelector('.popup-overlay');
						if (popupOverlay) {
							popupOverlay.classList.remove('show');
						}
					});
				} else {
					const hashFacility = document.querySelector('.facility-card[data-facility="' + hash + '"]');
					hashFacility.scrollIntoView({ behavior: 'smooth', block: 'center' });
					hashFacility.querySelector('.facility-popup').classList.add('open');
					// Add the "show" class to .popup-overlay when "open" is added
					const popupOverlay = document.body.querySelector('.popup-overlay');
					if (popupOverlay) {
						popupOverlay.classList.add('show');
						$('body').addClass('overlay-active');
					}
				}
			} else {
				// When there's no hash, remove the "show" class from .popup-overlay
				const popupOverlay = document.body.querySelector('.popup-overlay');
				if (popupOverlay) {
					popupOverlay.classList.remove('show');
					$('body').removeClass('overlay-active');
				}
			}
		}

		// Check if .popup-overlay exists before adding the event listener
		$('.popup-overlay').on('click', function () {
			console.log('click');
			$('.popup-overlay').removeClass('show');
			$('.facility-popup').removeClass('open');
			$('body').removeClass('overlay-active');
			window.location.hash = '/';
		});

		

		hashHandler();
		window.addEventListener('hashchange', function () {
			hashHandler();
		}, false);

		facilitycards.forEach(function (card) {
			card.addEventListener('click', function () {
				facilitycards.forEach(otherCard =>
					otherCard.querySelector('.facility-popup').classList.remove('open')
				);
				const slug = card.dataset.facility;
				card.querySelector('.facility-popup').classList.add('open');
				// Add the "show" class to .popup-overlay when "open" is added
				const popupOverlay = document.body.querySelector('.popup-overlay');
				if (popupOverlay) {
					popupOverlay.classList.add('show');
					$('body').addClass('overlay-active');
				}
				window.location.hash = '/' + slug + '/';
			});
		});

		const facilityclosebuttons = document.querySelectorAll('.facility-card .facility-close');
		facilityclosebuttons.forEach(function (button) {
			button.addEventListener('click', function (event) {
				button.parentElement.parentElement.classList.remove('open');
				window.location.hash = '/';
				event.stopPropagation();
				// Remove the "show" class from .popup-overlay when "open" is removed
				const popupOverlay = document.body.querySelector('.popup-overlay');
				if (popupOverlay) {
					popupOverlay.classList.remove('show');
					$('body').removeClass('overlay-active');
				}
			});
		});
	}
};
